/* unplugin-vue-components disabled */import script from "./authDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./authDialog.vue?vue&type=script&lang=ts&setup=true"

import "./authDialog.vue?vue&type=style&index=0&id=b986fc1c&lang=scss"

const __exports__ = script;

export default __exports__